import { createResourceReducer, typedResourceService } from './resourceReducer'

const { reducer, actions, thunks } = createResourceReducer({
    sliceName: 'podcasts',
    label: 'Podcast',
    service: typedResourceService('Podcast'),
})

export const { appendResource: appendPodcast, destroyResource: destroyPodcast, changeResource: changePodcast } = actions
export const { initializeResources: initializePodcasts, deleteResource: deletePodcast, searchResources: searchPodcasts, refreshResource: refreshPodcast } = thunks

// Children travel inline on the parent payload; the backend reconciles them by omission.
export const createPodcast = (data, list) => thunks.createResource({ ...data, sub_podcasts: list || [] })

export const updatePodcast = (id, data, podcasts, admin) => thunks.updateResource(id, { ...data, sub_podcasts: podcasts }, admin)

export default reducer
